import { useEffect } from 'react'
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  CardText,
  CardSubtitle,
  CardHeader,
  CardFooter,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'
import { AiFillHome } from 'react-icons/ai'
import '../Card.css'

const CardInfo = ({ text }) => {
  useEffect(() => {
    const activePage = window.location.pathname
    const navLinks = document
      .querySelectorAll('.items-navbar')
      .forEach((link) => {
        if (link.href.includes(`${activePage}`)) {
          link.classList.add('active')
        }
      })
  })

  return (
    <>
      <Row>
        <Col>
          <div>
            <Card className="principal">
              <CardHeader>
                <CardTitle className="title">Marauders Society</CardTitle>
                <CardSubtitle className="subtitle">
                  "I Solemnly Swear That I Am Up to No Good"
                </CardSubtitle>
              </CardHeader>
              <CardBody>
                <CardText className="text">{text}</CardText>
              </CardBody>
              <CardFooter>
                <div className="navbar">
                  <Nav>
                    <Row className="sections">
                      <Col>
                        <NavItem>
                          <NavLink className="items-navbar" href="/home">
                            {' '}
                            <AiFillHome />{' '}
                          </NavLink>
                        </NavItem>
                      </Col>
                      <Col>
                        <NavItem>
                          <NavLink className="items-navbar" href="/rules">
                            {' '}
                            Regras{' '}
                          </NavLink>
                        </NavItem>
                      </Col>
                      <Col>
                        <NavItem>
                          <NavLink className="items-navbar" href="/events">
                            {' '}
                            Acontecimentos{' '}
                          </NavLink>
                        </NavItem>
                      </Col>
                      <Col>
                        <NavItem>
                          <NavLink className="items-navbar" href="/apply">
                            {' '}
                            Ficha{' '}
                          </NavLink>
                        </NavItem>
                      </Col>
                      <Col>
                        <NavItem>
                          <NavLink
                            className="static-nav"
                            target="_blank"
                            href="https://docs.google.com/document/d/1K9F5ipJmPCOuFTZOTiuWr7vP3NmBexZgezbKehUZh8Y/edit?usp=sharing"
                          >
                            {' '}
                            Personagens{' '}
                          </NavLink>
                        </NavItem>
                      </Col>
                    </Row>
                  </Nav>
                </div>
              </CardFooter>
            </Card>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default CardInfo
